import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme) {
  return {
    input: {
      paddingTop: theme.spacing.xs,
      paddingBottom: theme.spacing.xs
    }
  };
});
export default useStyles;